// extracted by mini-css-extract-plugin
module.exports = {"material-name-text":"_3WDPyII3RUlMGbAd8T95dQ=="};